(function () {
  'use strict';

  angular
    .module('app')
    .component('paymentProviderRelatedTransactions', paymentProviderRelatedTransactions());

  function paymentProviderRelatedTransactions() {
    return {
      bindings: {
        paymentProvider: '<',
        providerId: '<',
      },
      controller: PaymentProviderRelatedTransactionsComponent,
      controllerAs: 'vm',
      templateUrl:
        './app/ajs/payment-providers/components/payment-provider-related-transactions/' +
        'payment-provider-related-transactions.component.html',
    };
  }

  PaymentProviderRelatedTransactionsComponent.$inject = [
    'PaymentProviderService',
    'RelatedTransactionService',
  ];

  function PaymentProviderRelatedTransactionsComponent(
    PaymentProviderService,
    RelatedTransactionService
  ) {
    let vm = this;

    // Methods
    vm.openRelatedTransactionModal = openRelatedTransactionModal;
    vm.selectTransaction = selectTransaction;

    vm.$onInit = function () {
      getRelatedTransactions();
    };

    function getRelatedTransactions() {
      vm.loadingRelatedTransactions = true;
      PaymentProviderService.getRelatedTransactions(vm.paymentProvider.id, vm.providerId).then(
        function (data) {
          vm.loadingRelatedTransactions = false;

          if (data.bills && data.bills.length > 0) {
            vm.bills = data.bills;
          }
          if (data.bookings && data.bookings.length > 0) {
            vm.bookings = data.bookings;
          }
          if (data.outgoings && data.outgoings.length > 0) {
            vm.outgoingPrepayments = data.outgoings;
          }

          vm.paymentProvider = data.paymentProvider;
        }
      );
    }

    function selectTransaction(transaction) {
      vm.transactionSelected = transaction;
      transaction.show = !transaction.show;
    }

    function openRelatedTransactionModal(transaction) {
      RelatedTransactionService.openRelatedTransactionModal(transaction);
    }
  }
})();
